import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 15.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V7.5c0-.917-.75-1.667-1.667-1.667H6.667C5.75 5.833 5 6.583 5 7.5zM7.5 7.5h5c.458 0 .833.375.833.833V15a.836.836 0 0 1-.833.833h-5A.836.836 0 0 1 6.667 15V8.333c0-.458.375-.833.833-.833m5.417-4.167-.592-.591a.84.84 0 0 0-.583-.242H8.258a.84.84 0 0 0-.583.242l-.592.591H5a.836.836 0 0 0-.833.834c0 .458.375.833.833.833h10a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrashIcon;
